import React from 'react';
import SEO from '../components/SEO';
import Header from "../partials/header/Header";
import ClarityAnalytics from '../components/ClarityAnalytics';
import GoogleAnalytics from '../components/GoogleAnalytics';
import IntroSlider from '../container/IntroSlider/IntroSlider';
import HomeAbout from '../components/About/HomeAbout.jsx';
import ServiceIconBox from '../container/service/ServiceIconBox';
// import HomeSuccess from '../components/Success/HomeSuccess';
import Portfolio from '../container/Portfolio/Portfolio';
import HomeBlog from '../container/BlogGrid/HomeBlog';
// import Newsletter from '../container/Newsletter/Newsletter';
// import ContactInformation from '../container/ContactInformation/ContactInformation';
import BrandContainer from '../container/Brand/BrandContainer';

import Footer from '../container/Footer/Footer';
import ScrollToTop from '../components/ScrollToTop.jsx';



const HomeOne = () => {
    return (
        <React.Fragment>
            {/* 修改标题 */}
            <SEO title="DMBD 2026 | The Eleventh International Conference on Data Mining and Big Data" />
            {/* 首页接入 Microsoft Clarity 监控 */}
            <ClarityAnalytics />
            {/* 首页接入 Google Analytics（gtag.js）监控 */}
            <GoogleAnalytics />
            <Header />
            <IntroSlider />
            <ServiceIconBox classOption="bg-color-1" />
            <HomeAbout />
            {/* <HomeSuccess /> */}
            <Portfolio />
            <HomeBlog />
            {/* <Newsletter /> */}
            {/* <ContactInformation /> */}
            {/* 从brand.json修改 */}
            <BrandContainer classOption="section-padding" />
            <Footer />
            <ScrollToTop />
        </React.Fragment>
    )
}

export default HomeOne;



